import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { useToggle } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'UiAccordeon',
  setup(__props) {

const isOpen = ref(false);
const toggleItem = useToggle(isOpen);

return { __sfc: true,isOpen, toggleItem }
}

})